// ======================================================================
// File Name       : SelectedCourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Table, Button, Form } from 'react-bootstrap';


class SelectedCourseList extends Component {

  render() {
    const { csvDownload } = this.props;
    const { addedCourseList } = csvDownload;
    const courseList = Object.keys(addedCourseList).sort((a, b) => {
      if (addedCourseList[a].addNew && !addedCourseList[b].addNew) {
        return -1;
      } else if (!addedCourseList[a].addNew && addedCourseList[b].addNew) {
        return 1;
      }
      if (addedCourseList[a].index < addedCourseList[b].index) {
        return -1;
      } else if (addedCourseList[a].index > addedCourseList[b].index) {
        return 1;
      }
      return 0;
    });

    return (
      <Col sm={12} className="padding-clear">
        <Col sm={2} className="margin-top-10 padding-left-right-clear">
          対象コース
        </Col>
        <Col sm={10} className="text-right padding-left-right-clear margin-bottom-5">
          <Button variant="default" onClick={this.props.handleRemoveAllCourses}>コース一括削除</Button>
        </Col>

        <Table id="scroll-table-course" striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-11">コース名</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {courseList.map((courseSecernId, index) => {
              const data = addedCourseList[courseSecernId];
              return (
                <tr key={index} className={data.addNew ? 'background_new_record' : ''}>
                  <td>{data.courseName}</td>
                  <td className="text-center">
                    <i
                      role="button"
                      className="bi bi-trash"
                      onClick={this.props.handleRemoveCourse.bind(this, courseSecernId)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Form.Group className="margin-top-20 text-center col-sm-12">
          <Button
            variant="default"
            className="btn-96 margin-right-10"
            onClick={this.props.onCancel}
          >
            戻る
          </Button>
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.props.onOK}
          >
            OK
          </Button>
        </Form.Group>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { csvDownload } = state;
  return { csvDownload };
};
export default connect(mapStateToProps)(SelectedCourseList);

